<template>
  <button
    type="button"
    class="p-1.5 transition-all"
    :class="buttonClass"
    @click.stop.prevent="toggleShareDialog"
  >
    <ShareIcon
      class="text-gray-500 transition-colors hover:text-gray-700"
      :class="iconClass"
    />
  </button>
</template>

<script setup lang="ts">
import { ShareIcon } from '@heroicons/vue/24/outline';

withDefaults(
  defineProps<{
    productId: number;
    buttonClass?: string;
    iconClass?: string;
    product?: Product;
  }>(),
  {
    buttonClass: '',
    iconClass: 'size-5',
  },
);

const emit = defineEmits<{
  'show-share-dialog': [];
}>();

function toggleShareDialog(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  emit('show-share-dialog');
}
</script>
